const utils = require("frontend-controller/lib/utils")
module.exports = {
	config: {
		roleOptionScope: 'protocol',
	},

	model: {
		entityTable: false,
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						}
					}
				}
			}
		}
	},

	methods: {

		showEdit: function(type, rowData){
			const attributes = (rowData || {}).attributes || {}

			if(type === 'protocolAction'){
				const entityID 		= attributes.entityID;
				const entityType 	= attributes.entityType;
				const entityContext = attributes.entityContext;
				// in case of component instances filled with corresponding componentID to prevent issues
				// loading a componentStructure by instanceIDs after the componentInstances has been deleted.
				const componentID 	= attributes.componentID;

				if(attributes.method === 'DELETE'){
					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:protocol.protocol.unableToOpenDeleteProtocolAction'
							}
						}, {
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					);
				}
				if(attributes.method === 'UPDATE_MOVE' || attributes.method === 'UPDATE_MOVE_ToAnotherRoute'){
					return this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:protocol.protocol.unableToOpenUpdateMoveProtocolAction'
							}
						}, {
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					);
				}

				let baseActionKey = `showEdit_${entityType}`
				if(entityContext !== 'route' && entityContext !== 'layout'){
					baseActionKey = `${baseActionKey}_${entityContext}`
				}
				const actionKey = `${baseActionKey}_inEffect`

				if(this.actions[baseActionKey] && entityID){
					return this.performAndStoreAction(
						actionKey,
						this.prepareAction(baseActionKey, undefined, {
							nodeData: rowData
						}, {
							source: {
								load: {
									componentData: {
										actions: {
											loadContent: {
												source: {
													load: {
														// grantCacheByETag: false,
														resourceFilters: {
															protocolActionID: attributes.protocolActionID,
															entityID,
															componentID
														},
														componentData: {
															config: {
																isProtocolActionForm: true
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}),
						true
					)
				}
			}
		},

		/**
		 * this function is used to handle the different kinds of errors.
		 * NOTE: if this function returns reject no error occurred (e.g., if the statusCode is 200)
		 * NOTE: if this function resolves the given context is allways the original context and NOT the error handling context.
		 *
		 * @param   context             {} - action perform context
		 *          {
		 *              component: ...
		 *              [action]: ...
		 *              error: {
		 *                  statusCode: <statusCode>            mixed - status code || 'clientError'
		 *                  name: <statusCode>                  string - error name
		 *                  errorCode: <statusCode>             string - error code
		 *                  message: <statusCode>               string - error message
		 *                  details: <statusCode>               string - error details
		 *                  [childErrors]: []                   [] - list of child errors
		 *              },
		 *              errorHandlingType: CONSTANTS.ERROR.HANDLING_TYPE[...]
		 *                                      int - this error handling type defines the state of error handling
		 *                                      e.g., has this error been thrown during error handling or has this error been thrown during custom error handling etc.
		 *                                      NOTE: this flag will be filled by CONSTANTS.ERROR.HANDLING_TYPE
		 *          }
		 * @returns Promise
		 */
		handleError: function(context){
			var baseError = utils.extractBaseError(context.error);

			if(
				(baseError.statusCode == 409 && baseError.errorCode === 'COMPONENT_TREE_VALIDATION_ERROR_5')
				||
				(baseError.statusCode == 404 && baseError.errorCode === 'COMPONENT_TREE_ERROR_7')
			){
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:protocol.protocol.errorDuringComponentStructurePreparation'
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				);
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		},

		showColumnDescription: function ($element, options) {
			this.triggerFind('showColumnDescription', options);
		},

		hideColumnDescription: function ($element, options) {
			this.triggerFind('hideColumnDescription', options);
		},
	}
};
